/**
 * Validates a URL for parent-mediated external navigation from widgets.
 * @param {string} raw
 * @returns {string|null} Normalized https URL or null if unsafe
 */
export function getSafeExternalUrl(raw) {
  if (!raw || typeof raw !== 'string') {
    return null;
  }
  const trimmed = raw.trim();
  if (!/^https:\/\//i.test(trimmed)) {
    return null;
  }
  try {
    const url = new URL(trimmed);
    if (url.protocol !== 'https:') {
      return null;
    }
    if (url.username || url.password) {
      return null;
    }
    return url.href;
  } catch {
    return null;
  }
}
